// Generated from the API's [Reads] declarations by apps/api/Tests/Architecture/WireTypesTests.cs. Do not edit.
// Regenerate: WIRE_TYPES_REGEN=1 dotnet test apps/api/Tests/HooverCanvassingApi.Tests.csproj --filter FullyQualifiedName~WireTypesTests

import type { EntityTag } from './entityTags.gen';

export const EndpointReads = {
  'GET /api/campaign-race': [
    'CampaignRace',
    'SavedVoteGoal',
    'Volunteer',
  ],
  'GET /api/campaign-race/goals': [
    'SavedVoteGoal',
    'Volunteer',
  ],
  'GET /api/campaigns/{campaignId}/express-consultant': [
    'TenantCampaign',
    'Volunteer',
  ],
  'GET /api/express/{code}': [
    'Volunteer',
  ],
  'GET /api/express/{code}/campaigns': [
    'CampaignUser',
    'TenantCampaign',
    'Volunteer',
    'WorkOrder',
  ],
  'GET /api/finance/dashboard/attention': [
    'BlockedContributionAttempt',
    'CampaignFinanceSettings',
    'Contribution',
    'DonorInfoRequest',
    'DuplicateContactFlag',
    'FinanceContact',
    'Loan',
    'TenantCampaign',
  ],
  'GET /api/finance/dashboard/last-filed-cash': [
    'CampaignFinanceSettings',
    'ComplianceReport',
    'FilingDeadline',
    'FinanceAuditLog',
    'TenantCampaign',
  ],
  'GET /api/finance/dashboard/roster': [
    'BankAccount',
    'BankConnection',
    'BankTransaction',
    'ImportBatch',
    'PaymentProcessor',
    'TenantCampaign',
  ],
  'GET /api/finance/dashboard/summary': [
    'CampaignFinanceSettings',
    'Contribution',
    'Expenditure',
    'TenantCampaign',
  ],
  'GET /api/finance/health': [
    'BankTransaction',
    'CampaignFinanceSettings',
    'ComplianceReport',
    'Contribution',
    'ContributionRefund',
    'Expenditure',
    'ExportBatch',
    'FilingDeadline',
    'JurisdictionReportingSchedule',
    'PriorFilingAttestation',
    'TenantCampaign',
    'TransactionFlag',
  ],
  'GET /api/finance/sort-inbox': [
    'BankAccount',
    'BankLinePayeeIdentification',
    'BankTransaction',
    'CampaignFinanceSettings',
    'ComplianceReport',
    'Contribution',
    'ContributionAttachment',
    'ContributionRefund',
    'DonorInfoRequest',
    'Expenditure',
    'ExportBatch',
    'ExportBatchMember',
    'FilingDeadline',
    'FinanceAuditLog',
    'FinanceContact',
    'Loan',
    'PaymentProcessor',
    'PriorFilingAttestation',
    'TenantCampaign',
  ],
  'GET /api/platform/race-catalog/states': [],
  'GET /api/platform/race-catalog/states/{state}/rollback': [],
  'GET /api/races': [],
  'GET /api/races/{id}': [],
  'GET /api/text-status/{token}/results-report': [
    'TextSendDetails',
    'WorkOrder',
  ],
  'GET /api/voter-data/places/match': [],
  'GET /api/voter-list/{token}': [
    'VoterDataDetails',
    'WorkOrder',
  ],
  'GET /api/work-orders/{id}/results-report': [
    'TextSendDetails',
    'WorkOrder',
  ],
} as const satisfies Record<string, readonly EntityTag[]>;
